/**
 * Thrown when a job can't be worked on in the call center, which only
 * handles tax drafts.
 */
export class JobNotSupportedError extends Error {
  constructor() {
    super('Job is not supported')
    this.name = 'JobNotSupportedError'
  }
}
